import { extend } from 'lodash';
import common from './common';

const { default: conf } = require(`./${process.env.NODE_ENV || 'development'}`);

export default extend(common, conf);
